import { ICONS } from '@ui/icons/types';

export enum WidgetType {
  Header = 'header',
  Paragraph = 'paragraph',
  Image = 'image',
  Video = 'video',
  Button = 'button',
  Divider = 'divider',
  Spacer = 'spacer',
  Social = 'social',
  Logo = 'logo',
  Footer = 'footer',
  DateTimeCard = 'dateTimeCard',
}

export interface WidgetDefinition {
  type: WidgetType;
  label: string;
  icon: (typeof ICONS)[keyof typeof ICONS];
}

export const WIDGET_DEFINITIONS: WidgetDefinition[] = [
  { type: WidgetType.Header, label: 'Heading', icon: ICONS.CONTENT_BLOCK_HEADING },
  { type: WidgetType.Paragraph, label: 'Paragraph', icon: ICONS.CONTENT_BLOCK_PARAGRAPH },
  { type: WidgetType.Image, label: 'Image', icon: ICONS.CONTENT_BLOCK_IMAGE },
  { type: WidgetType.Video, label: 'Video', icon: ICONS.CONTENT_BLOCK_VIDEO },
  { type: WidgetType.Button, label: 'Button', icon: ICONS.CONTENT_BLOCK_BUTTON },
  { type: WidgetType.Divider, label: 'Divider', icon: ICONS.CONTENT_BLOCK_DIVIDER },
  { type: WidgetType.Spacer, label: 'Spacer', icon: ICONS.CONTENT_BLOCK_SPACER },
  { type: WidgetType.Social, label: 'Social', icon: ICONS.CONTENT_BLOCK_SOCIAL },
  { type: WidgetType.Logo, label: 'Logo', icon: ICONS.CONTENT_BLOCK_LOGO },
  { type: WidgetType.DateTimeCard, label: 'Date & Time', icon: ICONS.CONTENT_BLOCK_DATE_TIME },
  { type: WidgetType.Footer, label: 'Footer', icon: ICONS.CONTENT_BLOCK_FOOTER },
];
